// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"c8b6e3ed","251":"bdc60915","561":"c4d0b72f","787":"b3f929bd","794":"4614bb54","987":"28222682"}[chunkId] + ".chunk.js";
};